import React from 'react';
import { styled } from 'styled-components';
import { computeRemSize } from '@ydistri/theme';
import { MdDifference } from 'react-icons/md';
import { COLORS } from '../../../../styles/style';
import { ICON_SIZE_COMPACT, ICON_SIZE_NORMAL } from './calculationRowLib';
import { Popover } from 'antd';

const EditedCalculationIndicatorWrapper = styled.div`
  margin-left: auto;
  color: ${COLORS.PRIMARY};
`;

interface EditedCalculationIndicatorProps {
  compact?: boolean;
}

const EditedCalculationIndicator: React.FC<EditedCalculationIndicatorProps> = ({ compact }) => {
  return (
    <Popover content="Calculation was manually edited">
      <EditedCalculationIndicatorWrapper data-type="indicator-calculation-edited">
        <MdDifference size={computeRemSize(compact ? ICON_SIZE_COMPACT : ICON_SIZE_NORMAL)} />
      </EditedCalculationIndicatorWrapper>
    </Popover>
  );
};

export default EditedCalculationIndicator;
